import { addEventListenerLive } from "../helpers/events";
const $ = require("jquery");
export const dismissNotice = (selector) => {
    document.querySelectorAll(selector).forEach((el) => {
        addEventListenerLive('click', '.ac-notice__dismiss, [data-dismiss], .notice-dismiss', (e) => {
            e.preventDefault();
            let data = el.dataset.dismissibleCallback ? JSON.parse(el.dataset.dismissibleCallback) : null;
            if (data) {
                $.post(ajaxurl, data);
            }
        }, el);
    });
};
export const initDismissibleNotices = () => {
    dismissNotice('.ac-notice');
};
